import { m, type Messages } from './index';

/** Label lookups that cover both the original sections and the phase-2 `places` section. */
type Places = Messages['places'];
type World3 = Messages['world3'];
type Trips = Messages['trips'];
export type ZoneKey = keyof Messages['zones'] | keyof Places['zones'] | keyof World3['zones'] | keyof Trips['zones'];
export type ObjLabel = keyof Messages['objects'] | keyof Places['objects'] | keyof World3['objects'] | keyof Trips['objects'];
export type NpcName = keyof Messages['npc'] | keyof Places['npc'] | keyof World3['npc'] | keyof Trips['npc'];

const TOUR = ['xinyi', 'ximen', 'cks', 'hlcity', 'taroko', 'airport', 'kaohsiung', 'tainan', 'barcelona'] as const;
/** The same sub-table from every phase E district namespace. */
function tour<K extends 'zones' | 'objects' | 'npc' | 'mapNames' | 'items'>(t: Messages, k: K): Messages[(typeof TOUR)[number]][K][] {
  return TOUR.map((n) => t[n][k]);
}

/** First table that has the key: original sections, then `places`, then `world3`. */
function look<T>(k: string, ...tables: Record<string, T>[]): T | undefined {
  for (const t of tables) if (k in t) return t[k];
  return undefined;
}

export function zoneName(k: string): string {
  const t = m();
  return look(k, t.zones, t.places.zones, t.world3.zones, t.trips.zones, t.sky.zones, t.family.zones, t.classroom.zones, t.life.zones, ...tour(t, 'zones')) ?? k;
}
export function objName(k: string): string {
  const t = m();
  return look(k, t.objects, t.places.objects, t.world3.objects, t.trips.objects, t.sky.objects, t.family.objects, t.classroom.objects, t.life.objects, ...tour(t, 'objects')) ?? k;
}
export function npcName(k: string): string {
  const t = m();
  return look(k, t.npc, t.places.npc, t.world3.npc, t.trips.npc, t.sky.npc, t.family.npc, t.classroom.npc, t.life.npc, ...tour(t, 'npc')) ?? k;
}
export function mapName(k: string): string {
  const t = m();
  return look(k, t.map.names, t.places.mapNames, t.world3.mapNames, t.trips.mapNames, t.sky.mapNames, t.family.mapNames, t.classroom.mapNames, t.life.mapNames, ...tour(t, 'mapNames')) ?? k;
}
export function itemInfo(k: string): { name: string; desc: string } {
  const t = m();
  return look<{ name: string; desc: string }>(k, t.bag.items, t.places.items, t.sky.items, t.family.items, t.classroom.items, t.life.items, t.story.items, ...tour(t, 'items')) ?? { name: k, desc: '' };
}
